<template>
  <div>
    <v-row>
      <v-col cols="12">
        Enter Your Company Placement Goals and Net Goals in Head Count by Month
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6" sm="3">
        <div class="month-section">
          <v-row>
            <v-col cols="12" class="pb-0">
              January
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <FormattedNumberField
                label="Goal"
                :value="placementGoalValue[0].goal"
                :onlyInt="true"
                :hideDetails="true"
                :outlined="false"
                @valueChange="(newValue) => this.placementGoalValue[0].goal = newValue"
              ></FormattedNumberField>
            </v-col>
            <v-col cols="6">
              <FormattedNumberField
                label="Net Goal"
                :value="placementGoalValue[0].netGoal"
                :onlyInt="true"
                :hideDetails="true"
                :outlined="false"
                @valueChange="(newValue) => this.placementGoalValue[0].netGoal = newValue"
              ></FormattedNumberField>
            </v-col>
          </v-row>
        </div>
      </v-col>
      <v-col cols="6" sm="3">
        <div class="month-section">
          <v-row>
            <v-col cols="12" class="pb-0">
              February
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <FormattedNumberField
                label="Goal"
                :value="placementGoalValue[1].goal"
                :onlyInt="true"
                :hideDetails="true"
                :outlined="false"
                @valueChange="(newValue) => this.placementGoalValue[1].goal = newValue"
              ></FormattedNumberField>
            </v-col>
            <v-col cols="6">
              <FormattedNumberField
                label="Net Goal"
                :value="placementGoalValue[1].netGoal"
                :onlyInt="true"
                :hideDetails="true"
                :outlined="false"
                @valueChange="(newValue) => this.placementGoalValue[1].netGoal = newValue"
              ></FormattedNumberField>
            </v-col>
          </v-row>
        </div>
      </v-col>
      <v-col cols="6" sm="3">
        <div class="month-section">
          <v-row>
            <v-col cols="12" class="pb-0">
              March
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <FormattedNumberField
                label="Goal"
                :value="placementGoalValue[2].goal"
                :onlyInt="true"
                :hideDetails="true"
                :outlined="false"
                @valueChange="(newValue) => this.placementGoalValue[2].goal = newValue"
              ></FormattedNumberField>
            </v-col>
            <v-col cols="6">
              <FormattedNumberField
                label="Net Goal"
                :value="placementGoalValue[2].netGoal"
                :onlyInt="true"
                :hideDetails="true"
                :outlined="false"
                @valueChange="(newValue) => this.placementGoalValue[2].netGoal = newValue"
              ></FormattedNumberField>
            </v-col>
          </v-row>
        </div>
      </v-col>
      <v-col cols="6" sm="3">
        <div class="month-section">
          <v-row>
            <v-col cols="12" class="pb-0">
              April
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <FormattedNumberField
                label="Goal"
                :value="placementGoalValue[3].goal"
                :onlyInt="true"
                :hideDetails="true"
                :outlined="false"
                @valueChange="(newValue) => this.placementGoalValue[3].goal = newValue"
              ></FormattedNumberField>
            </v-col>
            <v-col cols="6">
              <FormattedNumberField
                label="Net Goal"
                :value="placementGoalValue[3].netGoal"
                :onlyInt="true"
                :hideDetails="true"
                :outlined="false"
                @valueChange="(newValue) => this.placementGoalValue[3].netGoal = newValue"
              ></FormattedNumberField>
            </v-col>
          </v-row>
        </div>
      </v-col>
      <v-col cols="6" sm="3">
        <div class="month-section">
          <v-row>
            <v-col cols="12" class="pb-0">
              May
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <FormattedNumberField
                label="Goal"
                :value="placementGoalValue[4].goal"
                :onlyInt="true"
                :hideDetails="true"
                :outlined="false"
                @valueChange="(newValue) => this.placementGoalValue[4].goal = newValue"
              ></FormattedNumberField>
            </v-col>
            <v-col cols="6">
              <FormattedNumberField
                label="Net Goal"
                :value="placementGoalValue[4].netGoal"
                :onlyInt="true"
                :hideDetails="true"
                :outlined="false"
                @valueChange="(newValue) => this.placementGoalValue[4].netGoal = newValue"
              ></FormattedNumberField>
            </v-col>
          </v-row>
        </div>
      </v-col>
      <v-col cols="6" sm="3">
        <div class="month-section">
          <v-row>
            <v-col cols="12" class="pb-0">
              June
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <FormattedNumberField
                label="Goal"
                :value="placementGoalValue[5].goal"
                :onlyInt="true"
                :hideDetails="true"
                :outlined="false"
                @valueChange="(newValue) => this.placementGoalValue[5].goal = newValue"
              ></FormattedNumberField>
            </v-col>
            <v-col cols="6">
              <FormattedNumberField
                label="Net Goal"
                :value="placementGoalValue[5].netGoal"
                :onlyInt="true"
                :hideDetails="true"
                :outlined="false"
                @valueChange="(newValue) => this.placementGoalValue[5].netGoal = newValue"
              ></FormattedNumberField>
            </v-col>
          </v-row>
        </div>
      </v-col>
      <v-col cols="6" sm="3">
        <div class="month-section">
          <v-row>
            <v-col cols="12" class="pb-0">
              July
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <FormattedNumberField
                label="Goal"
                :value="placementGoalValue[6].goal"
                :onlyInt="true"
                :hideDetails="true"
                :outlined="false"
                @valueChange="(newValue) => this.placementGoalValue[6].goal = newValue"
              ></FormattedNumberField>
            </v-col>
            <v-col cols="6">
              <FormattedNumberField
                label="Net Goal"
                :value="placementGoalValue[6].netGoal"
                :onlyInt="true"
                :hideDetails="true"
                :outlined="false"
                @valueChange="(newValue) => this.placementGoalValue[6].netGoal = newValue"
              ></FormattedNumberField>
            </v-col>
          </v-row>
        </div>
      </v-col>
      <v-col cols="6" sm="3">
        <div class="month-section">
          <v-row>
            <v-col cols="12" class="pb-0">
              August
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <FormattedNumberField
                label="Goal"
                :value="placementGoalValue[7].goal"
                :onlyInt="true"
                :hideDetails="true"
                :outlined="false"
                @valueChange="(newValue) => this.placementGoalValue[7].goal = newValue"
              ></FormattedNumberField>
            </v-col>
            <v-col cols="6">
              <FormattedNumberField
                label="Net Goal"
                :value="placementGoalValue[7].netGoal"
                :onlyInt="true"
                :hideDetails="true"
                :outlined="false"
                @valueChange="(newValue) => this.placementGoalValue[7].netGoal = newValue"
              ></FormattedNumberField>
            </v-col>
          </v-row>
        </div>
      </v-col>
      <v-col cols="6" sm="3">
        <div class="month-section">
          <v-row>
            <v-col cols="12" class="pb-0">
              September
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <FormattedNumberField
                label="Goal"
                :value="placementGoalValue[8].goal"
                :onlyInt="true"
                :hideDetails="true"
                :outlined="false"
                @valueChange="(newValue) => this.placementGoalValue[8].goal = newValue"
              ></FormattedNumberField>
            </v-col>
            <v-col cols="6">
              <FormattedNumberField
                label="Net Goal"
                :value="placementGoalValue[8].netGoal"
                :onlyInt="true"
                :hideDetails="true"
                :outlined="false"
                @valueChange="(newValue) => this.placementGoalValue[8].netGoal = newValue"
              ></FormattedNumberField>
            </v-col>
          </v-row>
        </div>
      </v-col>
      <v-col cols="6" sm="3">
        <div class="month-section">
          <v-row>
            <v-col cols="12" class="pb-0">
              October
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <FormattedNumberField
                label="Goal"
                :value="placementGoalValue[9].goal"
                :onlyInt="true"
                :hideDetails="true"
                :outlined="false"
                @valueChange="(newValue) => this.placementGoalValue[9].goal = newValue"
              ></FormattedNumberField>
            </v-col>
            <v-col cols="6">
              <FormattedNumberField
                label="Net Goal"
                :value="placementGoalValue[9].netGoal"
                :onlyInt="true"
                :hideDetails="true"
                :outlined="false"
                @valueChange="(newValue) => this.placementGoalValue[9].netGoal = newValue"
              ></FormattedNumberField>
            </v-col>
          </v-row>
        </div>
      </v-col>
      <v-col cols="6" sm="3">
        <div class="month-section">
          <v-row>
            <v-col cols="12" class="pb-0">
              November
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <FormattedNumberField
                label="Goal"
                :value="placementGoalValue[10].goal"
                :onlyInt="true"
                :hideDetails="true"
                :outlined="false"
                @valueChange="(newValue) => this.placementGoalValue[10].goal = newValue"
              ></FormattedNumberField>
            </v-col>
            <v-col cols="6">
              <FormattedNumberField
                label="Net Goal"
                :value="placementGoalValue[10].netGoal"
                :onlyInt="true"
                :hideDetails="true"
                :outlined="false"
                @valueChange="(newValue) => this.placementGoalValue[10].netGoal = newValue"
              ></FormattedNumberField>
            </v-col>
          </v-row>
        </div>
      </v-col>
      <v-col cols="6" sm="3">
        <div class="month-section">
          <v-row>
            <v-col cols="12" class="pb-0">
              December
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <FormattedNumberField
                label="Goal"
                :value="placementGoalValue[11].goal"
                :onlyInt="true"
                :hideDetails="true"
                :outlined="false"
                @valueChange="(newValue) => this.placementGoalValue[11].goal = newValue"
              ></FormattedNumberField>
            </v-col>
            <v-col cols="6">
              <FormattedNumberField
                label="Net Goal"
                :value="placementGoalValue[11].netGoal"
                :onlyInt="true"
                :hideDetails="true"
                :outlined="false"
                @valueChange="(newValue) => this.placementGoalValue[11].netGoal = newValue"
              ></FormattedNumberField>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { FormattedNumberField } from '@/components/shared/textFields'

export default {
  components: {
    FormattedNumberField
  },
  props: [
    'placementGoals'
  ],
  computed: {
    placementGoalValue: {
      get () {
        return this.placementGoals
      },
      set (newValue) {
        this.$emit('placementGoalChange', newValue)
      }
    }
  }
}
</script>

<style>
.month-section {
  border: 1px solid #cccccc;
  padding: 10px;
  border-radius: 7px;
}
</style>
